import { useNavigate } from 'react-router-dom';

const CookiesPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md overflow-hidden  mt-0 md:mt-16">
        <div className="bg-green-600 px-6 py-4">
          <h1 className="text-2xl font-bold text-white">Política de Cookies - Dominus</h1>
          <p className="text-green-100 mt-1">Última atualização: 30 de abril de 2025</p>
        </div>

        <div className="p-6 space-y-10">
        <section className="mb-12">
            <div className="flex items-center mb-6 pb-2 border-b border-gray-200">
              <span className="text-2xl mr-2">🍪</span>
              <h2 className="text-xl font-bold text-gray-800">1. POLÍTICA DE COOKIES</h2>
            </div>
            
            <div className="space-y-8">
              {/* 3.1 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.1. O que são cookies?</h3>
                <p className="text-gray-700">
                  Cookies são pequenos arquivos de texto armazenados no seu navegador que ajudam a melhorar sua experiência no site.
                </p>
              </div>
              
              {/* 3.2 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.2. Tipos de cookies utilizados</h3>
                <ul className="pl-5 list-disc text-gray-700 space-y-1">
                  <li>Cookies essenciais: garantem o funcionamento do site;</li>
                  <li>Cookies de desempenho: coletam dados para análise e melhoria da navegação;</li>
                  <li>Cookies de marketing: ajudam a oferecer anúncios mais relevantes para você.</li>
                </ul>
              </div>
              
              {/* 3.3 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.3. Gerenciamento de cookies</h3>
                <p className="text-gray-700">
                  Você pode aceitar ou recusar cookies diretamente nas configurações do seu navegador. A desativação pode impactar algumas funcionalidades do site.
                </p>
              </div>
              
              {/* 3.4 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">1.4. Alterações</h3>
                <p className="text-gray-700">
                  A política de cookies pode ser atualizada sem aviso prévio. Recomendamos a revisão periódica.
                </p>
              </div>
            </div>
          </section>
        </div>

        <div className="mt-8 px-6 pb-6">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicyPage;
